<template>
  <div class="login-page">
    <div class="login-panel">
      <div class="login-header">
        <h1>企业周报系统</h1>
      </div>

      <el-form :model="form" label-position="top" @submit.prevent="handleLogin">
        <el-form-item label="登录身份">
          <el-radio-group v-model="form.role">
            <el-radio-button label="enterprise">企业用户</el-radio-button>
            <el-radio-button label="admin">管理员</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="账号">
          <el-input v-model="form.account" placeholder="企业编码或管理员账号" />
        </el-form-item>

        <el-form-item label="密码">
          <el-input v-model="form.password" show-password placeholder="请输入密码" />
        </el-form-item>

        <el-button type="primary" :loading="submitting" class="submit-btn" @click="handleLogin">
          登录
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';

import { login } from '../../api/auth';
import { useUserStore } from '../../store/user';

const router = useRouter();
const userStore = useUserStore();
const submitting = ref(false);

const form = reactive({
  role: 'enterprise',
  account: '',
  password: ''
});

const handleLogin = async () => {
  if (!form.account || !form.password) {
    ElMessage.warning('请输入账号和密码');
    return;
  }

  submitting.value = true;
  try {
    const result = await login(form);
    userStore.setSession(result.data.token, result.data.user);
    ElMessage.success('登录成功');
    router.push({ name: 'dashboard' });
  } catch (error) {
    ElMessage.error(error.response?.data?.message || '登录失败');
  } finally {
    submitting.value = false;
  }
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #eef2ff;
}

.login-panel {
  width: min(100%, 420px);
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 28px;
}

.login-header {
  margin-bottom: 24px;
}

.login-header h1 {
  margin: 0;
  font-size: 28px;
}

.submit-btn {
  width: 100%;
}
</style>
